import React from "react";
import ReactTooltip from "react-tooltip";
import Modal from "react-modal";
import PropTypes from "prop-types";

import Social from "./Social";
const PortfolioDetailsTile = ({ project, toggleModal, projectKey }) => {
  // function toggleModal() {
  //   project.setModalState(!project.modalState);
  // }
  return (
    <>
      <li data-aos="fade-right" data-aos-duration="1200">
        <div className="inner">
          <div className="entry tokyo_tm_portfolio_animation_wrap">
            <img
              src={project.images[0]}
              alt="Details"
              data-tip
              data-for={`project${projectKey}`}
              onClick={() => toggleModal(projectKey)}
            />

            <ReactTooltip
              id={`project${projectKey}`}
              place="bottom"
              type="light"
              effect="float"
              className="tooltip-wrapper"
            >
              <div>
                <h5>{project.title}</h5>
                <span>Click to learn more</span>
              </div>
            </ReactTooltip>
          </div>
        </div>
      </li>

      <Modal
        isOpen={project.modalState}
        onRequestClose={() => toggleModal(projectKey)}
        contentLabel="My dialog"
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={500}
      >
        <div className="tokyo_tm_modalbox_news portfolio_tm_modalbox">
          <button
            className="close-modal"
            onClick={() => toggleModal(projectKey)}
          >
            <img src="assets/img/svg/cancel.svg" alt="close icon" />
          </button>
          {/* END CLOSE ICON */}
          <div className="box_inner">
            <div className="description_wrap scrollable">
              <div className="image">
                {/* TODO maybe throw this img out. Seems like it might be here as an image hack */}
                <img src="assets/img/thumbs/4-3.jpg" alt="tumb" />
                <div
                  className="main"
                  style={{
                    backgroundImage: `url(${project.images[0]})`,
                  }}
                ></div>
              </div>
              {/* END IMAGE */}
              <div className="portfolio_main_title">
                <h3>{project.title}</h3>
                <span>{project.subtitle}</span>
              </div>
              {/* END portfolio_main_title */}
              <div className="main_details">
                <div className="textbox">
                  {project.description.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
                <div className="detailbox">
                  <ul>
                    <li>
                      <span className="first">Test It Out</span>
                      <span>
                        <a
                          style={{ textDecoration: "underline" }}
                          rel="noreferrer"
                          target="_blank"
                          href={project.host}
                        >
                          link
                        </a>
                      </span>
                    </li>
                    <li>
                      <span className="first">Tech Stack</span>
                      <span>MERN</span>
                    </li>
                    <li>
                      <span className="first">Skills</span>
                      <span>{project.skills}</span>
                    </li>
                    {project.monolithRepo ? (
                      <li>
                        <span className="first">Codebase</span>
                        <span>
                          <a
                            style={{ textDecoration: "underline" }}
                            rel="noreferrer"
                            target="_blank"
                            href={project.monolithRepo}
                          >
                            link
                          </a>
                        </span>
                      </li>
                    ) : (
                      <>
                        <li>
                          <span className="first">Client Repository</span>
                          <span>
                            <a
                              style={{ textDecoration: "underline" }}
                              rel="noreferrer"
                              target="_blank"
                              href={project.clientRepo}
                            >
                              link
                            </a>
                          </span>
                        </li>
                        <li>
                          <span className="first">Server Repository</span>
                          <span>
                            <a
                              style={{ textDecoration: "underline" }}
                              rel="noreferrer"
                              target="_blank"
                              href={project.serverRepo}
                            >
                              link
                            </a>
                          </span>
                        </li>
                      </>
                    )}
                    <li>
                      <span className="first">Date</span>
                      <span>{project.date}</span>
                    </li>
                    <li>
                      <span className="first">My Other Work</span>
                      <Social />
                      {/* END SOCIAL SHARE */}
                    </li>
                  </ul>
                </div>
              </div>
              {/* main_details */}

              <div className="additional_images">
                <ul className="gallery_zoom">
                  <li>
                    <div className="list_inner">
                      <div className="my_image">
                        <img src="img/thumbs/4-2.jpg" alt="thumb" />
                        <div
                          className="main"
                          style={{
                            backgroundImage: `url(${project.images[1]})`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </li>
                  {/* END SHOT */}
                  <li>
                    <div className="list_inner">
                      <div className="my_image">
                        <img src="img/thumbs/4-2.jpg" alt="thumb" />
                        <div
                          className="main"
                          style={{
                            backgroundImage: `url(${project.images[2]})`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </li>
                  {/* END SHOT */}
                  <li>
                    <div className="list_inner">
                      <div className="my_image">
                        <img src="img/thumbs/4-2.jpg" alt="thumb" />
                        <div
                          className="main"
                          style={{
                            backgroundImage: `url(${project.images[3]})`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </li>
                  {/* END SHOT */}
                </ul>
              </div>
            </div>
          </div>
          {/* END BOX INNER */}
        </div>
        {/* END MODALBOX NEWS */}
      </Modal>
    </>
  );
};

PortfolioDetailsTile.propTypes = {
  project: PropTypes.object,
  toggleModal: PropTypes.Function,
  projectKey: PropTypes.number,
};

export default PortfolioDetailsTile;
